/** @format Anirudh Sharma */

import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { UserManual } from "../usermanual";

const Main = ({ socket }) => {
  const navigate = useNavigate(); 

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login"); 
    }
  }, [navigate]);

  if (!localStorage.getItem("token")) {
    return null;
  }

  return (
    <div className="wrapper">
      <Sidebar />
      <div id="content">
        <Header socket={socket} />
        <Outlet />
        <UserManual />
      </div>
    </div>
  );
};

export default Main;
